<template>
  <div
    ref="cellValueWrapper"
    class="tender-list-cell tender-list-cell_value spacex-4"
    :contenteditable="cellCanBeEdited"
    :class="{
      'cursor-not-allowed': !cellCanBeEdited,
      'cell-can-be-edited': cellCanBeEdited,
    }"
    @blur="blurCellValue($event, { rowId: row.id, key: field })"
    @keydown="keydownCellValueHandler"
    @paste="keydownCellValue"
    @click="focusValue"
  >
    <div
      v-if="currency && isNumber && !isQuantity && !hideValues"
      class="table-cell-currency"
      contenteditable="false"
    >
      {{ currencySymbols[currency] }}
    </div>
    <div
      v-if="!hideValues"
      :id="cellId"
      ref="cellValue"
      class="tender-list-cell__value"
      @click.stop
    >
      {{ value || `&nbsp;` }}
    </div>
  </div>
</template>

<script>
  import addSpaces from '@/utils/formatting/add-spaces';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import contenteditableCell from '@/utils/mixins/contenteditable-cell';
  import tableNavigation from '@/utils/mixins/table-navigation';
  import TABLES_IDS from '@/utils/constants/tables-ids';

  export default {
    name: 'IncomingTenderListCell',
    props: {
      row: {
        type: Object,
        required: true,
      },
      field: {
        type: String,
        required: true,
      },
      currency: {
        type: String,
        default: '',
      },
      contentEditable: {
        type: Boolean,
        default: false,
      },
      isNumber: {
        type: Boolean,
        default: true,
      },
      isQuantity: {
        type: Boolean,
        default: false,
      },
      isBreakdown: {
        type: Boolean,
        default: false,
      },
      hideValues: {
        type: Boolean,
        default: false,
      },
      // Список айдишников строк, по которым можно производить навигацию стрелочками и табом,
      // исключает родительские групповые строки, скрытые строки и строки с брейкдауном (их нельзя редачить)
      orderOfRowsIds: {
        type: Array,
        default: () => [],
      },
      orderOfFieldsToEdit: {
        type: Array,
        default: () => [],
      },
    },
    mixins: [contenteditableCell, tableNavigation],
    data() {
      return {
        // константа для подстановки в миксин
        MAX_NUMBER_LENGTH: 9,
      };
    },
    computed: {
      ...mapState('global', ['currencySymbols']),
      ...mapState('focusedValue', ['focusedValue']),
      ...mapGetters({
        isNotInvitedIncomingTender: 'incomingTender/isNotInvitedIncomingTender',
      }),
      cellCanBeEdited() {
        return this.contentEditable && !this.isNotInvitedIncomingTender;
      },
      value() {
        if (this.isNumber) {
          return addSpaces(this.row[this.field]);
        }
        return this.row[this.field];
      },
    },
    methods: {
      ...mapActions('focusedValue', ['setFocusedValue']),
      async keydownCellValueHandler(e) {
        const newCellId = await this.keydownCellValueMixinHandler(e, {
          rowsIds: this.orderOfRowsIds,
          fields: this.orderOfFieldsToEdit,
          currentRowId: this.row.id,
          currentField: this.field,
          isBreakdown: this.isBreakdown,
          currentCellId: this.cellId,
          value: this.value,
          tableId: TABLES_IDS.INCOMING_TENDER_TABLE_ID,
        });
        if (newCellId && newCellId !== this.cellId) {
          await this.focusValue(null, newCellId);
        }
      },
    },
  };
</script>
